import { render, staticRenderFns } from "./rJiezhenDai.vue?vue&type=template&id=1a7856b8&scoped=true&"
import script from "./rJiezhenDai.vue?vue&type=script&lang=js&"
export * from "./rJiezhenDai.vue?vue&type=script&lang=js&"
import style0 from "./rJiezhenDai.vue?vue&type=style&index=0&id=1a7856b8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7856b8",
  null
  
)

export default component.exports